import EmptyState from '@components/EmptyState'
import React from 'react'

const ProgramExpired: React.FC = () => {
  return (
    <EmptyState
      heading="You cannot book lessons as your program has expired."
      img="/images/locked.svg"
      bodyTxt="Please contact your learning center for more information, or raise a case using the button below."
      linkUrl="/support/contact-us/?id=technical-support"
      btnTxt="Raise a case"
      top="md"
    />
  )
}

export default ProgramExpired
